<template>
  <ul v-if="stylingImages.length > 0" class="styling-images">
    <li v-for="image in stylingImages" :key="image.image.media">
      <img :src="image.image.media" />
    </li>
  </ul>

  <div class="wysiwyg">
    <p v-for="(paragraph, index) in stylingDescription" :key="index">
      {{ paragraph }}
    </p>
    <template v-if="hasMultipleVariants">
      <p>
        Not sure what size to buy? Find your correct size with our
        <a class="easysize_button">size and fit recommender.</a>
      </p>
    </template>
  </div>
</template>

<script>
import { unwrapNodes } from "@/helpers/graphql";
import { mapState } from "vuex";

export default {
  name: "Styling",
  computed: {
    ...mapState("product", ["product"]),
    stylingImages() {
      return unwrapNodes(this.product.stylingImages?.references?.edges) || [];
    },
    stylingDescription() {
      const str = this.product.stylingDescription.value;
      const paragraphs = str.split(/\r?\n/);
      return paragraphs;
    },
    hasMultipleVariants() {
      const options = this.product.options;
      return options.some((option) => option.values.length > 1);
    },
  },
};
</script>

<styling lang="scss" scoped>
.styling-images {
  display: flex;
  overflow-x: auto;
  flex-flow: row nowrap;
  gap: 2px;
  margin-bottom: 10px;

  & > * {
    flex: 1 0 auto;
  }
}

.wysiwyg p {
  @include t__utility-body-20;
  a.easysize_button {
    background: none;
    border: none;
    display: inline;
    text-decoration: underline;
    padding: 0;
    @include t__utility-body-20;
    &::before {
      display: none;
    }
  }
}
</styling>
